import template from "./smart-registration-search-details.html"

(function ($, ko) {
    ko.components.register('smart-registration-search-details', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new SmartRegistrationSearchDetails(params, updateContainerHeight(componentInfo.element));
            }
        }
    });

    function SmartRegistrationSearchDetails(params, updateHeight) {
        const self = this;

        self.searchEmployeeRequest = new $.cdh.post.smartRegistration.searchEmployee();        

        self.model = {
            firstName: ko.observable().extend({required: true, maxLength: 50}),
            lastName: ko.observable().extend({required: true, maxLength: 50}),
            zipCode: ko.observable().extend({ required: true, zipCode: true })
        };

        self.validation = new $.cdh.validation(self.model);

        self.isLoading = ko.pureComputed(function() {
           return self.searchEmployeeRequest.isLoading();
        });
        
        self.submit = function() {
            if (self.isLoading())
                return;
            
            self.validation.activate();
            
            if(!self.validation.hasErrors()) {
                self.sendData();
            }
        };
        
        self.sendData = function() {
            return self.searchEmployeeRequest.load(self.model).done(function (result) {
                params.model.onNext(result);
            }).fail(function() { updateHeight(); });
        };
        
        self.cancel = params.model.onCancel;
        
        params.model.clear = function() {
            self.model.firstName(null);
            self.model.lastName(null);
            self.model.zipCode(null);
            
            self.validation.deactivate(true);

            self.searchEmployeeRequest.setData(null);
        };
    }

})(jQuery, ko);